import { DEV_DEFAULTS } from './dev-defaults';
export class MockRemoteConfigProvider {
    constructor() {
        this._config = new Map(Object.entries(DEV_DEFAULTS));
    }
    getValue(key, fallback) {
        const value = this._config.get(key);
        return value !== undefined ? value : fallback;
    }
    getAll() {
        return Object.fromEntries(this._config);
    }
    async fetch() {
        // DEV mock — already loaded from DEV_DEFAULTS
    }
}
